
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { int32ToString, equals, stringHash, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { isEmpty, map, ofArray, singleton } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { collect, map as map_1, empty, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { chat, flow, coin, checkList, loss, grid, medical, gauge, truck, excavator, wrench, laptop, arrowRight, arrowLeft, plus, check } from "./Icons.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { replace, concat, substring } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { createElement } from "react";
import React from "react";
import { Variant as Variant_2 } from "../Variant.js";
import { List_distinct } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { toList as toList_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { Msg, Step } from "./Types.js";
import { Button, TextButton } from "../Components/Button.js";
import { map as map_2, defaultArg, unwrap } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { contains } from "../fable_modules/fable-library-js.5.0.0-rc.2/Set.js";
import { createDisposable, useEffectDisposableOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { update as update_1, init as init_1, canAdvance } from "./State.js";
import { useTranslation } from "react-i18next";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";

const accent = "#0FB5A8";

const accentSoft = "#E6F7F5";

const accentHover = "#0C9E92";

const ink = "#0B0F12";

const ink2 = "#3A4149";

const ink3 = "#6B7380";

const line = "#E5E8EC";

const lineHover = "#CBD1D8";

const bg = "#F6F7F8";

const card = "#FFFFFF";

const tileMuted = "#F3F5F7";

const shadowSm = "0 1px 2px rgba(11,15,18,0.04)";

const shadowMd = "0 10px 30px rgba(11,15,18,0.08)";

const animations = reactElement("style", createObj(singleton((() => {
    const content = "\n@keyframes mwkFadeUp { from { opacity:0; transform:translateY(12px);} to { opacity:1; transform:translateY(0);} }\n@keyframes mwkPulse { 0%,100% { transform:scale(1);} 50% { transform:scale(1.04);} }\n@keyframes mwkPop { 0% { transform:scale(0.5); opacity:0; } 60% { transform:scale(1.1);} 100% { transform:scale(1); opacity:1; }}\n@keyframes mwkSlide { to { transform:translateX(0); } }\n";
    return ["dangerouslySetInnerHTML", {
        __html: content,
    }];
})())));

function selectIndicator(selected, floatingMode) {
    let elems;
    return reactElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(floatingMode ? singleton_1(["position", "absolute"]) : empty(), delay(() => append(floatingMode ? singleton_1(["top", 14 + "px"]) : empty(), delay(() => append(floatingMode ? singleton_1(["right", 14 + "px"]) : empty(), delay(() => append(singleton_1(["width", 20 + "px"]), delay(() => append(singleton_1(["height", 20 + "px"]), delay(() => append(singleton_1(["borderRadius", 999]), delay(() => append(singleton_1(["border", (((2 + "px ") + "solid") + " ") + (selected ? accent : "#C8CED5")]), delay(() => append(singleton_1(["backgroundColor", selected ? accent : "transparent"]), delay(() => append(singleton_1(["display", "flex"]), delay(() => append(singleton_1(["alignItems", "center"]), delay(() => append(singleton_1(["justifyContent", "center"]), delay(() => append(singleton_1(["flexShrink", 0]), delay(() => append(singleton_1(["transition", "all 160ms ease"]), delay(() => singleton_1(["color", "white"]))))))))))))))))))))))))))))))], (elems = toList(delay(() => (selected ? singleton_1(check(12)) : singleton_1(defaultOf())))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function keySuffix(key) {
    return substring(key, key.lastIndexOf(".") + 1);
}

function selectedAttribute(selected) {
    return ["data-selected", selected ? "true" : "false"];
}

function categoryTestId(category) {
    switch (category) {
        case "toolsAndEquipment":
            return "onboarding-wizard-category-tools-equipment";
        case "constructionMachinery":
            return "onboarding-wizard-category-construction";
        case "vehicles":
            return "onboarding-wizard-category-vehicles";
        case "testEquipment":
            return "onboarding-wizard-category-test-equipment";
        case "medicalEquipment":
            return "onboarding-wizard-category-medical";
        case "otherCategory":
            return "onboarding-wizard-category-other";
        default:
            return "onboarding-wizard-category-it-mobiliar";
    }
}

class CardStyle extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CardStyleCard", "CardStyleTile"];
    }
}

function CardStyle_$reflection() {
    return union_type("OnboardingWizard.View.CardStyle", [], CardStyle, () => [[], []]);
}

function OptionCard(props) {
    let elems_3, elems;
    const patternInput = reactApi.useState(false);
    const setHover = patternInput[1];
    const hover = patternInput[0];
    const border = props.Selected ? accent : (hover ? lineHover : line);
    if (props.Style.tag === 0) {
        return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], selectedAttribute(props.Selected), ["onClick", (_arg_3) => {
            props.OnClick();
        }], ["onMouseEnter", (_arg_4) => {
            setHover(true);
        }], ["onMouseLeave", (_arg_5) => {
            setHover(false);
        }], ["style", createObj(toList(delay(() => append(singleton_1(["position", "relative"]), delay(() => append(singleton_1(["display", "flex"]), delay(() => append(singleton_1(["flexDirection", "column"]), delay(() => append(singleton_1(["gap", 12 + "px "]), delay(() => append(singleton_1(["padding", ((((((18 + "px") + " ") + (18 + "px")) + " ") + (16 + "px")) + " ") + (18 + "px")]), delay(() => append(singleton_1(["cursor", "pointer"]), delay(() => append(singleton_1(["userSelect", "none"]), delay(() => append(singleton_1(["backgroundColor", card]), delay(() => append(singleton_1(["border", (((2 + "px ") + "solid") + " ") + border]), delay(() => append(singleton_1(["borderRadius", 10]), delay(() => append(singleton_1(["transition", "all 160ms ease"]), delay(() => append(props.Selected ? singleton_1(["boxShadow", (((((0 + "px ") + 1) + "px ") + 2) + "px ") + "rgba(11,15,18,0.04)"]) : empty(), delay(() => append(props.Selected ? singleton_1(["outline", concat("3px solid ", accent, ..."22")]) : empty(), delay(() => ((hover && !props.Selected) ? singleton_1(["transform", ("translateY(" + (-2 + "px")) + ")"]) : empty()))))))))))))))))))))))))))))))], (elems_3 = toList(delay(() => {
            let matchValue_2, iconFn, elems_1;
            return append((matchValue_2 = props.Icon, (matchValue_2 == null) ? singleton_1(defaultOf()) : ((iconFn = matchValue_2, singleton_1(reactElement("div", createObj(ofArray([["style", {
                width: 44 + "px",
                height: 44 + "px",
                borderRadius: 10,
                backgroundColor: props.Selected ? accentSoft : tileMuted,
                color: props.Selected ? accent : ink2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 160ms ease",
            }], (elems_1 = [iconFn(22)], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))))), delay(() => {
                let elems_2;
                return append(singleton_1(reactElement("div", createObj(ofArray([["style", {
                    flexGrow: 1,
                }], (elems_2 = toList(delay(() => append(singleton_1(reactElement("div", {
                    style: {
                        fontSize: 15 + "px",
                        fontWeight: 600,
                        color: ink,
                        lineHeight: 1.3,
                    },
                    children: props.Label,
                })), delay(() => {
                    const matchValue_3 = props.Description;
                    if (matchValue_3 == null) {
                        return singleton_1(defaultOf());
                    }
                    else {
                        const desc_1 = matchValue_3;
                        return singleton_1(reactElement("div", {
                            style: {
                                fontSize: 13 + "px",
                                color: ink3,
                                marginTop: 4,
                                lineHeight: 1.45,
                            },
                            children: desc_1,
                        }));
                    }
                })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => singleton_1(selectIndicator(props.Selected, true))));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    }
    else {
        return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], selectedAttribute(props.Selected), ["onClick", (_arg) => {
            props.OnClick();
        }], ["onMouseEnter", (_arg_1) => {
            setHover(true);
        }], ["onMouseLeave", (_arg_2) => {
            setHover(false);
        }], ["style", createObj(toList(delay(() => append(singleton_1(["position", "relative"]), delay(() => append(singleton_1(["display", "flex"]), delay(() => append(singleton_1(["flexDirection", "column"]), delay(() => append(singleton_1(["alignItems", "center"]), delay(() => append(singleton_1(["justifyContent", "center"]), delay(() => append(singleton_1(["gap", 4 + "px "]), delay(() => append(singleton_1(["textAlign", "center"]), delay(() => append(singleton_1(["minHeight", 82]), delay(() => append(singleton_1(["padding", ((16 + "px") + " ") + (10 + "px")]), delay(() => append(singleton_1(["cursor", "pointer"]), delay(() => append(singleton_1(["userSelect", "none"]), delay(() => append(singleton_1(["backgroundColor", props.Selected ? accentSoft : card]), delay(() => append(singleton_1(["border", (((2 + "px ") + "solid") + " ") + border]), delay(() => append(singleton_1(["borderRadius", 10]), delay(() => append(singleton_1(["transition", "all 160ms ease"]), delay(() => (props.Selected ? singleton_1(["outline", concat("3px solid ", accent, ..."22")]) : empty()))))))))))))))))))))))))))))))))))], (elems = toList(delay(() => append(singleton_1(reactElement("div", {
            style: {
                fontSize: 16 + "px",
                fontWeight: 700,
                color: props.Selected ? accent : ink,
                lineHeight: 1.2,
                whiteSpace: "nowrap",
            },
            children: props.Label,
        })), delay(() => {
            const matchValue_1 = props.Description;
            if (matchValue_1 == null) {
                return singleton_1(defaultOf());
            }
            else {
                const desc = matchValue_1;
                return singleton_1(reactElement("div", {
                    style: {
                        fontSize: 12 + "px",
                        color: ink3,
                        lineHeight: 1.3,
                        whiteSpace: "nowrap",
                    },
                    children: desc,
                }));
            }
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function OtherCard(props) {
    let elems_4, elems_2, elems, elems_1, elems_3;
    const patternInput = reactApi.useState(false);
    const setHover = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const setFocus = patternInput_1[1];
    const focus = patternInput_1[0];
    const borderColor = props.Selected ? accent : (patternInput[0] ? "#BFC6CE" : "#D4DAE1");
    return reactElement("div", createObj(ofArray([["onMouseEnter", (_arg) => {
        setHover(true);
    }], ["onMouseLeave", (_arg_1) => {
        setHover(false);
    }], ["style", createObj(toList(delay(() => append(singleton_1(["backgroundColor", card]), delay(() => append(singleton_1(["border", (((2 + "px ") + "dashed") + " ") + borderColor]), delay(() => append(singleton_1(["borderRadius", 10]), delay(() => append(singleton_1(["padding", ((16 + "px") + " ") + (18 + "px")]), delay(() => append(singleton_1(["transition", "all 160ms ease"]), delay(() => (props.Selected ? singleton_1(["boxShadow", (((((0 + "px ") + 1) + "px ") + 2) + "px ") + "rgba(11,15,18,0.04)"]) : empty()))))))))))))))], (elems_4 = [reactElement("div", createObj(ofArray([["data-test-id", props.TestId], selectedAttribute(props.Selected), ["onClick", (_arg_2) => {
        props.OnToggle();
    }], ["style", {
        display: "flex",
        alignItems: "center",
        gap: 14 + "px ",
        cursor: "pointer",
    }], (elems_2 = [reactElement("div", createObj(ofArray([["style", {
        width: 38 + "px",
        height: 38 + "px",
        borderRadius: 8,
        backgroundColor: props.Selected ? accentSoft : tileMuted,
        color: props.Selected ? accent : ink2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }], (elems = [plus(20)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
    }], (elems_1 = [reactElement("div", {
        style: {
            fontSize: 15 + "px",
            fontWeight: 600,
            color: ink,
        },
        children: props.Label,
    }), reactElement("div", {
        style: {
            fontSize: 13 + "px",
            color: ink3,
            marginTop: 2,
        },
        children: props.Description,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), selectIndicator(props.Selected, false)], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton_1(["overflow", "hidden"]), delay(() => append(singleton_1(["transition", "all 200ms ease"]), delay(() => (props.Selected ? append(singleton_1(["maxHeight", 80 + "px"]), delay(() => singleton_1(["marginTop", 14 + "px"]))) : append(singleton_1(["maxHeight", 0]), delay(() => singleton_1(["marginTop", 0])))))))))))], (elems_3 = [reactElement("input", {
        "data-test-id": concat(props.TestId, ..."-text"),
        value: props.Value,
        onChange: (ev) => {
            props.OnValueChange(ev.target.value);
        },
        placeholder: props.Placeholder,
        onFocus: (_arg_3) => {
            setFocus(true);
        },
        onBlur: (_arg_4) => {
            setFocus(false);
        },
        style: createObj(toList(delay(() => append(singleton_1(["width", 100 + "%"]), delay(() => append(singleton_1(["padding", ((11 + "px") + " ") + (14 + "px")]), delay(() => append(singleton_1(["border", (((2 + "px ") + "solid") + " ") + (focus ? accent : line)]), delay(() => append(singleton_1(["borderRadius", 8]), delay(() => append(singleton_1(["fontSize", 14 + "px"]), delay(() => append(singleton_1(["fontFamily", "inherit"]), delay(() => append(singleton_1(["color", ink]), delay(() => append(singleton_1(["backgroundColor", card]), delay(() => append(singleton_1(["outlineStyle", "none"]), delay(() => append(singleton_1(["transition", "all 140ms ease"]), delay(() => (focus ? singleton_1(["box-shadow", concat("0 0 0 3px ", ...accentSoft)]) : empty())))))))))))))))))))))))),
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function TextBox(props) {
    const patternInput = reactApi.useState(false);
    const setFocus = patternInput[1];
    const focus = patternInput[0];
    return reactElement("input", {
        "data-test-id": props.TestId,
        value: props.Value,
        onChange: (ev) => {
            props.OnChange(ev.target.value);
        },
        placeholder: props.Placeholder,
        autoFocus: props.AutoFocus,
        onFocus: (_arg) => {
            setFocus(true);
        },
        onBlur: (_arg_1) => {
            setFocus(false);
        },
        style: createObj(toList(delay(() => append(singleton_1(["width", 100 + "%"]), delay(() => append(singleton_1(["padding", ((11 + "px") + " ") + (14 + "px")]), delay(() => append(singleton_1(["border", (((2 + "px ") + "solid") + " ") + (focus ? accent : line)]), delay(() => append(singleton_1(["borderRadius", 8]), delay(() => append(singleton_1(["fontSize", 14 + "px"]), delay(() => append(singleton_1(["fontFamily", "inherit"]), delay(() => append(singleton_1(["color", ink]), delay(() => append(singleton_1(["backgroundColor", card]), delay(() => append(singleton_1(["outlineStyle", "none"]), delay(() => append(singleton_1(["transition", "all 140ms ease"]), delay(() => (focus ? singleton_1(["box-shadow", concat("0 0 0 3px ", ...accentSoft)]) : empty())))))))))))))))))))))))),
    });
}

function componentState(disabled) {
    if (disabled) {
        return "disabled";
    }
    else {
        return "enabled";
    }
}

function stepHeader(t, eyebrowKey, titleKey, subtitleKey) {
    let elems;
    return reactElement("div", createObj(ofArray([["style", {
        marginBottom: 28 + "px",
    }], (elems = [reactElement("div", {
        style: {
            fontSize: 12 + "px",
            letterSpacing: 0.14 + "em",
            textTransform: "uppercase",
            fontWeight: 600,
            color: accent,
            marginBottom: 10 + "px",
        },
        children: t(eyebrowKey),
    }), reactElement("h1", {
        style: {
            fontSize: 30 + "px",
            fontWeight: 800,
            letterSpacing: -0.02 + "em",
            margin: ((((((0 + "px ") + 0) + "px ") + 10) + "px ") + 0) + "px",
            lineHeight: 1.15,
            color: ink,
        },
        children: t(titleKey),
    }), reactElement("p", {
        style: {
            fontSize: 15 + "px",
            color: ink3,
            margin: 0,
            lineHeight: 1.5,
            maxWidth: 620 + "px",
        },
        children: t(subtitleKey),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function fieldLabel(label, hint) {
    let elems_1;
    return reactElement("div", createObj(ofArray([["style", {
        marginBottom: 12 + "px",
    }], (elems_1 = toList(delay(() => {
        let elems;
        return append(singleton_1(reactElement("div", createObj(ofArray([["style", {
            fontSize: 15 + "px",
            fontWeight: 600,
            color: ink,
        }], (elems = [label, reactElement("span", {
            style: {
                color: accent,
                marginLeft: 4 + "px",
            },
            children: "*",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            const matchValue = hint;
            if (matchValue == null) {
                return singleton_1(defaultOf());
            }
            else {
                const h = matchValue;
                return singleton_1(reactElement("div", {
                    style: {
                        fontSize: 13 + "px",
                        color: ink3,
                        marginTop: 3 + "px",
                    },
                    children: h,
                }));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function topBar(t, step) {
    let elems;
    const label = (step.tag === 3) ? "" : ((step.tag === 1) ? replace(replace(t("onboarding.wizard.step_of"), "{{current}}", "1"), "{{total}}", "2") : ((step.tag === 2) ? replace(replace(t("onboarding.wizard.step_of"), "{{current}}", "2"), "{{total}}", "2") : ""));
    return reactElement("div", createObj(ofArray([["style", {
        height: 64 + "px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: ((0 + "px") + " ") + (32 + "px"),
        borderBottom: (((1 + "px ") + "solid") + " ") + line,
        backgroundColor: "white",
        flexShrink: 0,
    }], (elems = [reactElement("img", {
        style: {
            height: 36 + "px",
        },
        alt: "Logo",
        src: (Variant_2.tag === 0) ? "assets/images/mwk_logo.png" : "assets/images/inventory-one-logo.png",
    }), reactElement("div", {
        style: {
            fontSize: 13 + "px",
            color: ink3,
            "font-variant-numeric": "tabular-nums",
        },
        children: label,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

const supportChatBubbleClearance = 96 + "px";

function validationMessages(t, formState) {
    let elems;
    const messages = List_distinct(map((tuple) => tuple[1], toList_1(formState.Validations)), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    });
    if (isEmpty(messages)) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(ofArray([["data-test-id", "onboarding-wizard-validation-message"], ["style", {
            flexBasis: 100 + "%",
            marginBottom: 4 + "px",
            padding: ((12 + "px") + " ") + (14 + "px"),
            borderRadius: 8,
            backgroundColor: "#FDECEC",
            color: "#B42318",
            fontSize: 14 + "px",
            lineHeight: 1.5,
        }], (elems = toList(delay(() => map_1((message) => reactElement("div", {
            children: t(message),
        }), messages))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function stepActions(t, step, canNext, formState, onBack, onNext) {
    let elems_2, elems, elems_1;
    const showNext = equals(step, new Step(1, [])) ? true : equals(step, new Step(2, []));
    const showBack = equals(step, new Step(2, []));
    const isLoading = formState.IsLoading;
    if (!showNext && !showBack) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(ofArray([["style", {
            borderTop: (((1 + "px ") + "solid") + " ") + line,
            marginTop: 32 + "px",
            marginBottom: supportChatBubbleClearance,
            paddingTop: 20 + "px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 14 + "px ",
            flexWrap: "wrap",
        }], (elems_2 = [validationMessages(t, formState), reactElement("div", createObj(singleton((elems = toList(delay(() => {
            let Label, Icon;
            return showBack ? singleton_1(createElement(TextButton, (Label = t("general.back"), (Icon = arrowLeft(16), {
                ComponentState: componentState(isLoading),
                Icon: unwrap(Icon),
                Label: Label,
                OnClick: onBack,
                TestId: "onboarding-wizard-back",
                Variant: "default",
            })))) : singleton_1(defaultOf());
        })), ["children", reactApi.Children.toArray(Array.from(elems))])))), reactElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 14 + "px ",
        }], (elems_1 = toList(delay(() => append(!canNext ? singleton_1(reactElement("div", {
            "data-test-id": "onboarding-wizard-required-hint",
            style: {
                fontSize: 12 + "px",
                color: ink3,
            },
            children: t("onboarding.wizard.required_hint"),
        })) : singleton_1(defaultOf()), delay(() => {
            let Label_1;
            return singleton_1(createElement(Button, (Label_1 = (equals(step, new Step(2, [])) ? t("onboarding.wizard.submit") : t("onboarding.wizard.next")), {
                ComponentState: componentState(!canNext ? true : isLoading),
                Label: Label_1,
                OnClick: onNext,
                TestId: equals(step, new Step(2, [])) ? "onboarding-wizard-submit" : "onboarding-wizard-next",
                Variant: "primary",
            })));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
    }
}

function stepPreviewCard(n, title, desc) {
    let elems;
    return reactElement("div", createObj(ofArray([["style", {
        backgroundColor: card,
        border: (((1 + "px ") + "solid") + " ") + line,
        borderRadius: 10,
        padding: ((((((16 + "px") + " ") + (16 + "px")) + " ") + (18 + "px")) + " ") + (16 + "px"),
        textAlign: "left",
    }], (elems = [reactElement("div", {
        style: {
            width: 26 + "px",
            height: 26 + "px",
            borderRadius: 999,
            backgroundColor: accentSoft,
            color: accent,
            fontSize: 13 + "px",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 10 + "px",
        },
        children: int32ToString(n),
    }), reactElement("div", {
        style: {
            fontSize: 14 + "px",
            fontWeight: 600,
            color: ink,
        },
        children: title,
    }), reactElement("div", {
        style: {
            fontSize: 13 + "px",
            color: ink3,
            marginTop: 2 + "px",
            lineHeight: 1.4,
        },
        children: desc,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function welcomeScreen(t, onStart) {
    let elems_2, elems_1, elems;
    return reactElement("div", createObj(ofArray([["data-test-id", "onboarding-wizard-step-welcome"], ["style", {
        width: 100 + "%",
        maxWidth: 620 + "px",
        marginLeft: "auto",
        marginRight: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        padding: ((40 + "px") + " ") + (24 + "px"),
        animation: "mwkFadeUp 500ms cubic-bezier(.2,.7,.2,1) both",
    }], (elems_2 = [reactElement("img", {
        style: {
            height: 88 + "px",
            width: "auto",
            marginBottom: 28 + "px",
        },
        alt: "Logo",
        src: (Variant_2.tag === 0) ? "assets/images/mwk_logo.png" : "assets/images/inventory-one-logo.png",
    }), reactElement("div", {
        style: {
            fontSize: 13 + "px",
            letterSpacing: 0.14 + "em",
            textTransform: "uppercase",
            color: ink3,
            fontWeight: 600,
            marginBottom: 14 + "px",
        },
        children: t("onboarding.wizard.welcome.eyebrow"),
    }), reactElement("h1", {
        style: {
            fontSize: 40 + "px",
            fontWeight: 800,
            letterSpacing: -0.02 + "em",
            margin: ((((((0 + "px ") + 0) + "px ") + 16) + "px ") + 0) + "px",
            lineHeight: 1.08,
            color: ink,
            textAlign: "center",
        },
        children: t("onboarding.wizard.welcome.title"),
    }), reactElement("p", {
        style: {
            fontSize: 17 + "px",
            lineHeight: 1.55,
            color: ink2,
            maxWidth: 500 + "px",
            margin: ((((((0 + "px ") + 0) + "px ") + 36) + "px ") + 0) + "px",
        },
        children: t("onboarding.wizard.welcome.subtitle"),
    }), reactElement("div", createObj(ofArray([["style", {
        display: "grid",
        "grid-template-columns": "1fr 24px 1fr",
        width: 100 + "%",
        maxWidth: 480 + "px",
        marginBottom: 36 + "px",
    }], (elems_1 = [stepPreviewCard(1, t("onboarding.wizard.welcome.step1_title"), t("onboarding.wizard.welcome.step1_desc")), reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: ink3,
    }], (elems = [arrowRight(18)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), stepPreviewCard(2, t("onboarding.wizard.welcome.step2_title"), t("onboarding.wizard.welcome.step2_desc"))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(Button, {
        ComponentState: "enabled",
        Label: t("onboarding.wizard.welcome.cta"),
        OnClick: onStart,
        TestId: "onboarding-wizard-start",
        Variant: "primary",
    }), reactElement("div", {
        style: {
            marginTop: 20 + "px",
            fontSize: 12 + "px",
            color: ink3,
        },
        children: t("onboarding.wizard.welcome.duration"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

const categoryItems = ofArray([["itAndMobiliar", laptop, "onboarding.wizard.category.it_mobiliar", "onboarding.wizard.category.it_mobiliar_desc"], ["toolsAndEquipment", wrench, "onboarding.wizard.category.tools_equipment", "onboarding.wizard.category.tools_equipment_desc"], ["constructionMachinery", excavator, "onboarding.wizard.category.construction", "onboarding.wizard.category.construction_desc"], ["vehicles", truck, "onboarding.wizard.category.vehicles", "onboarding.wizard.category.vehicles_desc"], ["testEquipment", gauge, "onboarding.wizard.category.test_equipment", "onboarding.wizard.category.test_equipment_desc"], ["medicalEquipment", medical, "onboarding.wizard.category.medical", "onboarding.wizard.category.medical_desc"]]);

function step1View(t, state, dispatch) {
    let elems_2, elems_1;
    return reactElement("div", createObj(ofArray([["data-test-id", "onboarding-wizard-step-categories"], (elems_2 = [stepHeader(t, "onboarding.wizard.step1.eyebrow", "onboarding.wizard.step1.title", "onboarding.wizard.step1.subtitle"), reactElement("div", createObj(ofArray([["style", {
        display: "grid",
        "grid-template-columns": "repeat(3, minmax(0,1fr))",
        gap: 12 + "px ",
        marginBottom: 14 + "px",
    }], (elems_1 = toList(delay(() => append(collect((matchValue) => {
        let Selected, Label;
        const cat = matchValue[0];
        return singleton_1(createElement(OptionCard, (Selected = contains(cat, state.SelectedCategories), (Label = t(matchValue[2]), {
            Description: t(matchValue[3]),
            Icon: matchValue[1],
            Label: Label,
            OnClick: () => {
                dispatch(new Msg(1, [cat, !contains(cat, state.SelectedCategories)]));
            },
            Selected: Selected,
            Style: new CardStyle(0, []),
            TestId: categoryTestId(cat),
        }))));
    }, categoryItems), delay(() => {
        let elems, Label_1;
        return singleton_1(reactElement("div", createObj(ofArray([["style", {
            "grid-column": "span 3",
        }], (elems = [createElement(OtherCard, (Label_1 = t("onboarding.wizard.other.label"), {
            Description: t("onboarding.wizard.category.other_desc"),
            Label: Label_1,
            OnToggle: () => {
                dispatch(new Msg(2, [!state.OtherCategorySelected]));
            },
            OnValueChange: (v) => {
                dispatch(new Msg(3, [v]));
            },
            Placeholder: t("onboarding.wizard.category.other_placeholder"),
            Selected: state.OtherCategorySelected,
            TestId: categoryTestId("otherCategory"),
            Value: state.OtherCategoryText,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

const employeeBuckets = ofArray([["1-10", "onboarding.wizard.employees.bucket_1_10"], ["11-50", "onboarding.wizard.employees.bucket_11_50"], ["51-100", "onboarding.wizard.employees.bucket_51_100"], ["101-500", "onboarding.wizard.employees.bucket_101_500"], ["501+", "onboarding.wizard.employees.bucket_501_plus"]]);

const toolBuckets = ofArray([["<100", "onboarding.wizard.tools.bucket_lt_100"], ["100-500", "onboarding.wizard.tools.bucket_100_500"], ["501-4000", "onboarding.wizard.tools.bucket_501_4000"], ["4001-10000", "onboarding.wizard.tools.bucket_4001_10000"], [">10000", "onboarding.wizard.tools.bucket_gt_10000"]]);

class Problem extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ProblemOverview", "ProblemToolLoss", "ProblemInspections", "ProblemCostControl", "ProblemProcessOptimization", "ProblemInternalCommunication"];
    }
}

function Problem_$reflection() {
    return union_type("OnboardingWizard.View.Problem", [], Problem, () => [[], [], [], [], [], []]);
}

const problemItems = ofArray([[new Problem(0, []), grid, "onboarding.wizard.problem.overview", "onboarding.wizard.problem.overview_desc"], [new Problem(1, []), loss, "onboarding.wizard.problem.tool_loss", "onboarding.wizard.problem.tool_loss_desc"], [new Problem(2, []), checkList, "onboarding.wizard.problem.inspections", "onboarding.wizard.problem.inspections_desc"], [new Problem(3, []), coin, "onboarding.wizard.problem.cost_control", "onboarding.wizard.problem.cost_control_desc"], [new Problem(4, []), flow, "onboarding.wizard.problem.process_optimization", "onboarding.wizard.problem.process_optimization_desc"], [new Problem(5, []), chat, "onboarding.wizard.problem.internal_communication", "onboarding.wizard.problem.internal_communication_desc"]]);

function isProblemSelected(state, p) {
    switch (p.tag) {
        case 1:
            return state.WantsReduceToolLoss;
        case 2:
            return state.WantsInspections;
        case 3:
            return state.WantsCostControl;
        case 4:
            return state.WantsProcessOptimization;
        case 5:
            return state.WantsInternalCommunication;
        default:
            return state.WantsOverview;
    }
}

function toggleProblem(dispatch, p, v) {
    switch (p.tag) {
        case 1: {
            dispatch(new Msg(7, [v]));
            break;
        }
        case 2: {
            dispatch(new Msg(8, [v]));
            break;
        }
        case 3: {
            dispatch(new Msg(9, [v]));
            break;
        }
        case 4: {
            dispatch(new Msg(10, [v]));
            break;
        }
        case 5: {
            dispatch(new Msg(11, [v]));
            break;
        }
        default:
            dispatch(new Msg(6, [v]));
    }
}

function solutionRow(t, state, dispatch, solution, labelKey, descKey, placeholderKey) {
    let elems_3;
    const selected = equals(state.CurrentSolution, solution);
    const needsText = (solution === "software") ? true : (solution === "otherSolution");
    const textValue = (solution === "software") ? state.CurrentSolutionSoftwareText : ((solution === "otherSolution") ? state.CurrentSolutionOtherText : "");
    const testId = concat("onboarding-wizard-solution-", ...keySuffix(labelKey));
    return reactElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton_1(["backgroundColor", card]), delay(() => append(singleton_1(["border", (((2 + "px ") + "solid") + " ") + (selected ? accent : line)]), delay(() => append(singleton_1(["borderRadius", 10]), delay(() => append(singleton_1(["padding", ((14 + "px") + " ") + (16 + "px")]), delay(() => append(singleton_1(["transition", "all 160ms ease"]), delay(() => (selected ? append(singleton_1(["boxShadow", (((((0 + "px ") + 1) + "px ") + 2) + "px ") + "rgba(11,15,18,0.04)"]), delay(() => singleton_1(["outline", concat("3px solid ", accent, ..."22")]))) : empty()))))))))))))))], (elems_3 = toList(delay(() => {
        let elems_1, elems;
        return append(singleton_1(reactElement("div", createObj(ofArray([["data-test-id", testId], selectedAttribute(selected), ["onClick", (_arg) => {
            dispatch(new Msg(14, [solution]));
        }], ["style", {
            display: "flex",
            alignItems: "center",
            gap: 12 + "px ",
            cursor: "pointer",
        }], (elems_1 = [selectIndicator(selected, false), reactElement("div", createObj(ofArray([["style", {
            flexGrow: 1,
        }], (elems = [reactElement("div", {
            style: {
                fontSize: 15 + "px",
                fontWeight: 600,
                color: ink,
            },
            children: t(labelKey),
        }), reactElement("div", {
            style: {
                fontSize: 13 + "px",
                color: ink3,
                marginTop: 2,
            },
            children: t(descKey),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_2;
            return needsText ? singleton_1(reactElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton_1(["overflow", "hidden"]), delay(() => append(singleton_1(["transition", "all 200ms ease"]), delay(() => (selected ? append(singleton_1(["maxHeight", 60 + "px"]), delay(() => singleton_1(["marginTop", 12 + "px"]))) : append(singleton_1(["maxHeight", 0]), delay(() => singleton_1(["marginTop", 0])))))))))))], (elems_2 = [createElement(TextBox, {
                AutoFocus: selected,
                OnChange: (v) => {
                    switch (solution) {
                        case "software": {
                            dispatch(new Msg(15, [v]));
                            break;
                        }
                        case "otherSolution": {
                            dispatch(new Msg(16, [v]));
                            break;
                        }
                        default:
                            undefined;
                    }
                },
                Placeholder: defaultArg(map_2(t, placeholderKey), ""),
                TestId: concat(testId, ..."-text"),
                Value: textValue,
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : singleton_1(defaultOf());
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function step2View(t, state, dispatch) {
    let elems_10, elems_9, elems_1, elems, elems_3, elems_2, elems_6, elems_5, elems_8, elems_7;
    return reactElement("div", createObj(ofArray([["data-test-id", "onboarding-wizard-step-details"], (elems_10 = [stepHeader(t, "onboarding.wizard.step2.eyebrow", "onboarding.wizard.step2.title", "onboarding.wizard.step2.subtitle"), reactElement("div", createObj(ofArray([["aria-disabled", state.FormState.IsLoading], ["style", createObj(toList(delay(() => append(singleton_1(["display", "flex"]), delay(() => append(singleton_1(["flexDirection", "column"]), delay(() => append(singleton_1(["gap", 28 + "px "]), delay(() => (state.FormState.IsLoading ? append(singleton_1(["pointerEvents", "none"]), delay(() => singleton_1(["opacity", 0.6]))) : empty()))))))))))], (elems_9 = [reactElement("div", createObj(singleton((elems_1 = [fieldLabel(t("onboarding.wizard.step2.employees"), t("onboarding.wizard.step2.employees_hint")), reactElement("div", createObj(ofArray([["style", {
        display: "grid",
        "grid-template-columns": "repeat(5, minmax(0,1fr))",
        gap: 10 + "px ",
    }], (elems = toList(delay(() => collect((matchValue) => {
        let Selected;
        const labelKey = matchValue[1];
        const id = matchValue[0];
        return singleton_1(createElement(OptionCard, (Selected = equals(state.NumberOfEmployees, id), {
            Label: t(labelKey),
            OnClick: () => {
                dispatch(new Msg(4, [id]));
            },
            Selected: Selected,
            Style: new CardStyle(1, []),
            TestId: concat("onboarding-wizard-employees-", ...keySuffix(labelKey)),
        })));
    }, employeeBuckets))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])))), reactElement("div", createObj(singleton((elems_3 = [fieldLabel(t("onboarding.wizard.step2.tools"), t("onboarding.wizard.step2.tools_hint")), reactElement("div", createObj(ofArray([["style", {
        display: "grid",
        "grid-template-columns": "repeat(5, minmax(0,1fr))",
        gap: 10 + "px ",
    }], (elems_2 = toList(delay(() => collect((matchValue_1) => {
        let Selected_1;
        const labelKey_1 = matchValue_1[1];
        const id_1 = matchValue_1[0];
        return singleton_1(createElement(OptionCard, (Selected_1 = equals(state.NumberOfTools, id_1), {
            Label: t(labelKey_1),
            OnClick: () => {
                dispatch(new Msg(5, [id_1]));
            },
            Selected: Selected_1,
            Style: new CardStyle(1, []),
            TestId: concat("onboarding-wizard-tools-", ...keySuffix(labelKey_1)),
        })));
    }, toolBuckets))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])))), reactElement("div", createObj(singleton((elems_6 = [fieldLabel(t("onboarding.wizard.step2.problems_title"), t("onboarding.wizard.step2.problems_hint")), reactElement("div", createObj(ofArray([["style", {
        display: "grid",
        "grid-template-columns": "repeat(3, minmax(0,1fr))",
        gap: 10 + "px ",
    }], (elems_5 = toList(delay(() => append(collect((matchValue_2) => {
        let Selected_2, Label_2;
        const p = matchValue_2[0];
        const labelKey_2 = matchValue_2[2];
        return singleton_1(createElement(OptionCard, (Selected_2 = isProblemSelected(state, p), (Label_2 = t(labelKey_2), {
            Description: t(matchValue_2[3]),
            Icon: matchValue_2[1],
            Label: Label_2,
            OnClick: () => {
                toggleProblem(dispatch, p, !isProblemSelected(state, p));
            },
            Selected: Selected_2,
            Style: new CardStyle(0, []),
            TestId: concat("onboarding-wizard-problem-", ...keySuffix(labelKey_2)),
        }))));
    }, problemItems), delay(() => {
        let elems_4, Label_3;
        return singleton_1(reactElement("div", createObj(ofArray([["style", {
            "grid-column": "span 3",
        }], (elems_4 = [createElement(OtherCard, (Label_3 = t("onboarding.wizard.other.label"), {
            Description: t("onboarding.wizard.problem.other_desc"),
            Label: Label_3,
            OnToggle: () => {
                dispatch(new Msg(12, [!state.OtherProblemSelected]));
            },
            OnValueChange: (v) => {
                dispatch(new Msg(13, [v]));
            },
            Placeholder: t("onboarding.wizard.problem.other_placeholder"),
            Selected: state.OtherProblemSelected,
            TestId: "onboarding-wizard-problem-other",
            Value: state.OtherProblemText,
        }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])))), reactElement("div", createObj(singleton((elems_8 = [fieldLabel(t("onboarding.wizard.step2.solution_title"), t("onboarding.wizard.step2.solution_hint")), reactElement("div", createObj(ofArray([["style", {
        display: "grid",
        "grid-template-columns": "repeat(2, minmax(0,1fr))",
        gap: 10 + "px ",
    }], (elems_7 = [solutionRow(t, state, dispatch, "nothing", "onboarding.wizard.solution.nothing", "onboarding.wizard.solution.nothing_desc", undefined), solutionRow(t, state, dispatch, "excel", "onboarding.wizard.solution.excel", "onboarding.wizard.solution.excel_desc", undefined), solutionRow(t, state, dispatch, "software", "onboarding.wizard.solution.software", "onboarding.wizard.solution.software_desc", "onboarding.wizard.solution.software_placeholder"), solutionRow(t, state, dispatch, "otherSolution", "onboarding.wizard.solution.other", "onboarding.wizard.solution.other_desc", "onboarding.wizard.solution.other_placeholder")], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))]))))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
}

function DoneScreen(doneScreenInputProps) {
    let elems_2, elems, elems_1;
    const onDone = doneScreenInputProps.onDone;
    const t = doneScreenInputProps.t;
    useEffectDisposableOnce(() => {
        const handle = window.setTimeout(() => {
            onDone();
        }, 1800);
        return createDisposable(() => {
            window.clearTimeout(handle);
        });
    });
    return reactElement("div", createObj(ofArray([["data-test-id", "onboarding-wizard-step-done"], ["style", {
        width: 100 + "%",
        maxWidth: 520 + "px",
        marginLeft: "auto",
        marginRight: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        padding: ((60 + "px") + " ") + (24 + "px"),
    }], (elems_2 = [reactElement("div", createObj(ofArray([["style", {
        width: 72 + "px",
        height: 72 + "px",
        borderRadius: 999,
        backgroundColor: accent,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        marginBottom: 24 + "px",
        "box-shadow": "0 12px 28px rgba(15,181,168,0.3)",
        animation: "mwkPop 380ms cubic-bezier(.2,1.4,.4,1) both",
    }], (elems = [check(36)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("h1", {
        style: {
            fontSize: 28 + "px",
            fontWeight: 800,
            letterSpacing: -0.02 + "em",
            margin: ((((((0 + "px ") + 0) + "px ") + 10) + "px ") + 0) + "px",
            color: ink,
        },
        children: t("onboarding.wizard.done.title"),
    }), reactElement("p", {
        style: {
            fontSize: 15 + "px",
            color: ink3,
            margin: 0,
        },
        children: t("onboarding.wizard.done.subtitle"),
    }), reactElement("div", createObj(ofArray([["style", {
        width: 220 + "px",
        height: 3 + "px",
        backgroundColor: line,
        borderRadius: 99,
        marginTop: 28 + "px",
        overflow: "hidden",
    }], (elems_1 = [reactElement("div", {
        style: {
            width: 100 + "%",
            height: 100 + "%",
            backgroundColor: accent,
            transform: "translateX(-100%)",
            animation: "mwkSlide 1.6s cubic-bezier(.7,.1,.3,1) forwards",
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function stepContent(t, state, dispatch) {
    let elems_1, elems;
    const maxWidth = ((state.Step.tag === 2) ? 880 : 820) | 0;
    return reactElement("div", createObj(ofArray([["style", {
        padding: ((48 + "px") + " ") + (32 + "px"),
        display: "flex",
        justifyContent: "center",
    }], (elems_1 = [reactElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
        maxWidth: maxWidth + "px",
    }], (elems = toList(delay(() => {
        let matchValue_1;
        return append((matchValue_1 = state.Step, (matchValue_1.tag === 1) ? singleton_1(step1View(t, state, dispatch)) : ((matchValue_1.tag === 2) ? singleton_1(step2View(t, state, dispatch)) : ((matchValue_1.tag === 3) ? singleton_1(createElement(DoneScreen, {
            t: t,
            onDone: () => {
                dispatch(new Msg(22, []));
            },
        })) : singleton_1(welcomeScreen(t, () => {
            dispatch(new Msg(0, []));
        }))))), delay(() => singleton_1(stepActions(t, state.Step, canAdvance(state), state.FormState, () => {
            dispatch(new Msg(18, []));
        }, () => {
            dispatch(new Msg(17, []));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function View(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1(props.OnWizardCompleted), update_1, (_arg, _arg_1) => {
    }), undefined, [props.OnWizardCompleted]);
    const state_1 = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["style", {
        height: 100 + "vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: bg,
    }], (elems_1 = [animations, topBar(t, state_1.Step), reactElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
    }], (elems = [stepContent(t, state_1, patternInput_1[1])], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

